"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyCarlineStrategies = applyCarlineStrategies;
const utils_1 = require("../../utils");
const carlineBaseStrategy_1 = require("./carlineBaseStrategy");
const carlineConsumptionFromRawStrategy_1 = require("./carlineConsumptionFromRawStrategy");
const carlineEmissionFromRawStrategy_1 = require("./carlineEmissionFromRawStrategy");
const carlineEnvkvStrategy_1 = require("./carlineEnvkvStrategy");
const strategies = [
    {
        name: "base",
        condition: () => true,
        strategy: carlineBaseStrategy_1.carlineBaseStrategy,
    },
    {
        name: "carlineConsumptionFromRaw",
        condition: (locale) => (0, utils_1.isGermanMarket)(locale),
        strategy: carlineConsumptionFromRawStrategy_1.carlineConsumptionFromRawStrategy,
    },
    {
        name: "carlineEmissionFromRaw",
        condition: (locale) => (0, utils_1.isGermanMarket)(locale),
        strategy: carlineEmissionFromRawStrategy_1.carlineEmissionFromRawStrategy,
    },
    {
        name: "enVKV",
        condition: (locale) => (0, utils_1.isGermanMarket)(locale),
        strategy: carlineEnvkvStrategy_1.carlineEnvkvStrategy,
    },
];
function applyCarlineStrategies(carline, locale, i18nlanguage) {
    const output = Object.assign(Object.assign({}, carline), { footnote: {
            reference: "",
        } });
    const result = strategies.reduce((prevVue, s) => {
        if (!s.condition(locale))
            return prevVue;
        return s.strategy({ carline, locale, i18nlanguage }, prevVue);
    }, output);
    return result;
}
